import { render, staticRenderFns } from "./HYGB4.vue?vue&type=template&id=781c0dee"
import script from "./HYGB4.vue?vue&type=script&lang=js"
export * from "./HYGB4.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports